import UUID from 'uuid/v5';
import dicelist from './dicelist.js';

const dicelistLength = dicelist.length;
const defaultNamespace = '902e27bb-b3fc-4685-9d3a-375ceee22c18';

export const getPhrase = (number = 3, sep = '-') => {
	number = typeof parseInt(number) === 'number' ? parseInt(number) : 3;
	let phrase = '';
	for (let i = 0; i < number; i++) {
		let item = dicelist[Math.floor(Math.random() * dicelistLength)];
		phrase += (i > 0 ? sep : '') + item;
	}
	return phrase;
};

export const getPhraseID = (phrase, namespace = defaultNamespace) => {
	return UUID(phrase, namespace);
};
